// Shared step-navigation status styling (job offer + campaign wizards). WCAG: label colour stays
// constant, only the icon/circle/outline change, and the "!" glyph carries the meaning.
export const stepCircleProps = (hasError, hasWarning, isDone, isActive) => ({
    bg: hasError ? "red.100" : hasWarning ? "orange.100" : isDone ? "green.100" : isActive ? "purple.500" : "gray.100",
    color: hasError ? "red.700" : hasWarning ? "orange.700" : isDone ? "green.700" : isActive ? "white" : "gray.600",
    label: hasError || hasWarning ? "!" : isDone ? "✓" : null,
});

// Outline colours meet the 3:1 non-text contrast ratio against a white/near-white background.
export const stepAlertBorderColor = (hasError, hasWarning) => (hasError ? "red.500" : hasWarning ? "orange.600" : undefined);

export const stepLabelColor = (isActive) => (isActive ? "gray.900" : "gray.600");
